export default __webpack_public_path__ + "static/media/slider_2.fedc8abd.png";